/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CourseRequestGroup } from '../../models/course-request-group';
import { CourseRequestGroupApiRespModel } from '../../models/course-request-group-api-resp-model';

export interface ApiRequestCourseResultGroupPost$Params {
      body?: CourseRequestGroup
}

export function apiRequestCourseResultGroupPost(http: HttpClient, rootUrl: string, params?: ApiRequestCourseResultGroupPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CourseRequestGroupApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiRequestCourseResultGroupPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CourseRequestGroupApiRespModel>;
    })
  );
}

apiRequestCourseResultGroupPost.PATH = '/api/Request/Course/ResultGroup';
